const categoryAssets = {
  // Football theme ("Anonymous Football Players"). Icon is a generic football
  // mark — the old FIFA wordmark is a licensed brand and must not be shown.
  WC26: {
    cardBackground: require('./categories/FIFA WC26/card_background.png'),
    charBackground: require('./categories/FIFA WC26/char_background.png'),
    charMock: require('./categories/FIFA WC26/char_mock.png'),
    icon: require('./categories/Football/icon.svg'),
  },
  F1: {
    cardBackground: require('./categories/F1/card_background.png'),
    charBackground: require('./categories/F1/char_background.png'),
    charMock: require('./categories/F1/char_mock.png'),
    icon: require('./categories/F1/icon.png'),
  },
  NBA: {
    cardBackground: require('./categories/NBA/card_background.png'),
    charBackground: require('./categories/NBA/char_background.png'),
    charMock: require('./categories/NBA/char_mock.png'),
    icon: require('./categories/NBA/icon.png'),
  },
  TENNIS: {
    cardBackground: require('./categories/Tennis/card_background.png'),
    charBackground: require('./categories/Tennis/char_background.png'),
    charMock: require('./categories/Tennis/char_mock.png'),
    icon: require('./categories/Tennis/icon.png'),
  },
  INVESTORS: {
    cardBackground: require('./categories/Investors/card_background.png'),
    charBackground: require('./categories/Investors/char_background.png'),
    charMock: require('./categories/Investors/char_mock.png'),
    icon: require('./categories/Investors/icon.png'),
  },
  SINGERS: {
    cardBackground: require('./categories/Artists/card_background.png'),
    charBackground: require('./categories/Artists/char_background.png'),
    charMock: require('./categories/Artists/char_mock.png'),
    icon: require('./categories/Artists/icon.png'),
  },
  ARTISTS: {
    cardBackground: require('./categories/Artists/card_background.png'),
    charBackground: require('./categories/Artists/char_background.png'),
    charMock: require('./categories/Artists/char_mock.png'),
    icon: require('./categories/Artists/icon.png'),
  },
  // Alias for environments where the football theme is seeded under the
  // FOOTBALL code instead of WC26.
  FOOTBALL: {
    cardBackground: require('./categories/FIFA WC26/card_background.png'),
    charBackground: require('./categories/FIFA WC26/char_background.png'),
    charMock: require('./categories/FIFA WC26/char_mock.png'),
    icon: require('./categories/Football/icon.svg'),
  },
};

export default categoryAssets;
